import React, { useRef } from "react";
import { useDispatch } from "react-redux";
import { Box, Divider, Paper, Typography } from "@mui/material";
import { formatReceiptDate } from "../../../utils/formatNocDate";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const formatDate = (dateStr: string) => {
  if (!dateStr) return new Date().toLocaleDateString("en-GB");
  const date = new Date(dateStr);
  const dd = String(date.getDate()).padStart(2, "0");
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const yyyy = date.getFullYear();
  return `${dd}.${mm}.${yyyy}`;
};
function capitalizeWords(str: string) {
  if (!str) return "";
  return str
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}
const RetailLicenseContent = ({
  feeDatails,
  userData,
  applicantdata,
  roDetails,
  bgDetails,
  paDetails,
}: any) => {
  const {
    village,
    taluka,
    district,
    khasra_number,
    state,
    national_highway_number,
    application_code,
    inspectionDate,
    application_date,
    authority_name,
    address_1,
    address_2,
    pincode,
    property_type,
    start_chainage,
    end_chainage,
    chainage,
    highway_side,
    location_type_name,
    plot_length_m,
    plot_width_m,
    created_by_uname,
    business_name,
    service_road_length,
    service_road_width,
  } = applicantdata || {};

  const chainageDisplay = start_chainage
    ? end_chainage
      ? `${start_chainage} to ${end_chainage}`
      : start_chainage
    : chainage || "";

  const navigate = useNavigate();

  React.useEffect(() => {
    if (
      applicantdata?.organizations?.[0]?.business_name === undefined ||
      applicantdata?.organizations?.[0]?.business_name?.length === 0
    ) {
      toast.error(
        "Please update your profile with valid business details and select category as 'Company/Organization' to Esign.",
      );
      navigate("/view-profile");
    }
  }, [applicantdata]);

  return (
    <>
      <style>
        {`
          .pdf-document,
          .pdf-document * {
            box-sizing: border-box;
          }

          .pdf-document {
            width: 100%;
            height: auto !important;
            min-height: 0 !important;
            overflow: visible !important;
            color: #000;
          }

          .pdf-document img {
            max-width: 100%;
            height: auto;
          }

          .pdf-document p,
          .pdf-document li,
          .pdf-document div,
          .pdf-document span {
            overflow-wrap: break-word;
          }

          @media print {
            @page {
              size: A4;
              margin: 8mm 10mm;
            }

            html,
            body {
              margin: 0 !important;
              padding: 0 !important;
              height: auto !important;
              overflow: visible !important;
            }

            .pdf-document {
              width: 100% !important;
              height: auto !important;
              min-height: 0 !important;
              overflow: visible !important;
              color: #000 !important;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }

            .pdf-document * {
              color: #000 !important;
            }
          }
        `}
      </style>

      <Box
        className="pdf-document"
        sx={{
          p: { xs: 1, md: 4 },
          width: "100%",
          maxWidth: "100%",
          minWidth: 0,
          margin: "0 auto",
          textAlign: "justify",
          fontSize: 18,
          lineHeight: 1.45,
          color: "#000",
          fontFamily: "Trebuchet MS, Arial, sans-serif",
          overflow: "visible",
          height: "auto",
          minHeight: 0,

          "& *": {
            boxSizing: "border-box",
            fontFamily: "Trebuchet MS, Arial, sans-serif",
            fontSize: "inherit",
          },

          "@media print": {
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
            padding: "8mm 10mm",
            fontSize: "14px",
            lineHeight: 1.45,
            color: "#000",
            overflow: "visible",
            height: "auto",
            minHeight: 0,
          },
        }}
      >
        <Paper
          elevation={2}
          sx={{
            p: { xs: 1, md: 4 },
            borderRadius: 3,
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
            height: "auto",
            minHeight: 0,
            overflow: "visible",
            "@media print": {
              boxShadow: "none",
              borderRadius: 0,
              padding: 0,
              margin: 0,
              width: "100%",
              maxWidth: "100%",
              height: "auto",
              minHeight: 0,
              overflow: "visible",
            },
          }}
        >
          {/* Header */}
          <img
            src={require("@assets/images/national-emblem.png")}
            alt="National Emblem"
            style={{
              display: "block",
              margin: "0 auto",
              width: 60,
              height: "auto",
              marginBottom: 16,
            }}
          />
          <Typography
            variant="h6"
            fontWeight={700}
            align="center"
            sx={{
              mb: 1,
              fontSize: "inherit",
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
            }}
          >
            Government of India
          </Typography>
          <Typography
            align="center"
            sx={{
              fontWeight: 500,
              fontSize: "inherit",
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
            }}
          >
            Ministry of Road Transport & Highways
          </Typography>
          <Typography
            align="center"
            sx={{
              fontWeight: 500,
              fontSize: "inherit",
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
            }}
          >
            Regional Office - {roDetails?.office_name || "____"}
          </Typography>
          {/* <Typography align="center" sx={{ fontWeight: 400, fontSize: "inherit" }}>
            {roDetails?.address_line1 || "____"},
            {/* {roDetails.address_line2 || "____"} */}
          {/* </Typography> */}
          {/* <Typography align="center" sx={{ fontWeight: 400, fontSize: "inherit" }}>
            Phone No. {roDetails?.contact_number || "____"} ,{" "}
            <mark>Phone/Fax No. +1 2125556254</mark>, Email-
            {roDetails?.email ? (
              <a href={`mailto:${roDetails.email}`}>{roDetails.email}</a>
            ) : (
              "____"
            )}
          </Typography> */}
          <Divider sx={{ my: 2 }} />

          {/* Title and Application Info */}
          <Typography
            variant="h6"
            fontWeight={700}
            sx={{
              mb: 1,
              textDecoration: "underline",
              textAlign: { xs: "right", md: "right" },
              fontSize: "inherit",
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
            }}
          >
            PROVISIONAL NOC
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
            <Typography>
              Application No.: <b>{application_code || ""}</b>
            </Typography>
            {/* <Typography>
              Dated: <b>{formatDate(new Date().toISOString())}</b>
            </Typography> */}
          </Box>

          {/* To Section */}
          <Typography
            sx={{
              mb: 1,
              fontSize: "inherit",
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
            }}
          >
            To
            <br />
            Authorised signatory,
            <br />
            {applicantdata?.loi_name && applicantdata?.loi_dealer_name ? (
              <>{applicantdata.loi_name}</>
            ) : applicantdata?.organizations?.[0]?.business_name ? (
              <>
                <br />
                {applicantdata.organizations[0].business_name}
                <br />
                {applicantdata.organizations[0].business_nature || ""}
                <br />
                {applicantdata.organizations[0].entity_type || ""}
                <br />
                {applicantdata.organizations[0].city_name || ""}
                {applicantdata.organizations[0].district_name
                  ? `, ${applicantdata.organizations[0].district_name}`
                  : ""}
                {applicantdata.organizations[0].state_name
                  ? `, ${applicantdata.organizations[0].state_name}`
                  : ""}
                {applicantdata.organizations[0].pincode
                  ? ` ${applicantdata.organizations[0].pincode}`
                  : ""}
              </>
            ) : null}
          </Typography>

          {/* Subject */}
          <Typography
            sx={{
              mb: 2,
              fontSize: "inherit",
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
            }}
          >
            <b>Subject:</b> Access application for proposed{" "}
            <b>{property_type || ""}</b> abutting NH-
            <b>{national_highway_number || "____"}</b> at KM{" "}
            <b>{chainageDisplay}</b>, <b>{highway_side}</b>, Khasra No./Block
            No./ Gat No./Survey No. <b>{khasra_number || "____"}</b>, village{" "}
            <b>{village || "____"}</b>, Taluka <b>{taluka || "____"}</b>,
            District <b>{district || "____"}</b> in the State / UT of{" "}
            <b>{state || "____"}</b>: regarding issue of Provisional NOC.
          </Typography>

          {/* Fees Details */}

          <Typography
            sx={{
              mb: 2,
              fontSize: "inherit",
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
            }}
          >
            <b>Fees Details:</b>
            <br />
            {feeDatails?.length > 0 &&
              feeDatails?.map((allfee: any, index: number) => (
                <div>
                  (i) Processing fees of Rs.
                  <b>
                    {allfee?.paymentStageId === 1
                      ? Number(allfee?.fees?.submittedFees ?? 0) -
                        Number(allfee?.fees?.penaltyAmount ?? 0)
                      : Number(allfee?.fees?.submittedFees ?? 0)}
                  </b>{" "}
                  (TRN no. <b>{allfee.transactionId}</b> dated{" "}
                  <b>
                    {" "}
                    {allfee?.transactionDate &&
                      formatDate(allfee?.transactionDate)}
                    )
                  </b>
                </div>
              ))}
            (iii) Bank Guarantee: bearing No.{" "}
            <b>{bgDetails?.bank_guarantee_no || "___"}</b> issued by{" "}
            <b>{bgDetails?.bg_bank_name || "___"} </b> Bank on{" "}
            <b>{formatDate(bgDetails?.bg_isssue_date) || "___"}</b> valid till{" "}
            <b>{formatDate(bgDetails?.bg_validity_date) || "___"}</b>
          </Typography>
          {/* <Typography sx={{ mb: 2 }}>
            <b>Fees Details:</b>
            <br />
            {feeDatails?.length > 0 &&
              feeDatails?.map((allfee: any, index: number) => (
                <div key={index}>
                  ({index + 1}) Processing fees of Rs.
                  {allfee?.fees?.netAmount} (TRN no. {allfee.transactionId}{" "}
                  dated {formatDate(allfee.transactionDate)})
                </div>
              ))}
            (4) Bank Guarantee: bearing No.{" "}
            <b>{bgDetails?.bank_guarantee_no || "___"}</b> issued by{" "}
            <b>{bgDetails?.bg_bank_name || "___"} </b> Bank on{" "}
            <b>{formatDate(bgDetails?.bg_isssue_date) || "___"}</b> valid till{" "}
            <b>{formatDate(bgDetails?.bg_validity_date) || "___"}</b>
          </Typography> */}

          {/* Body */}
          <Typography
            sx={{
              mb: 2,
              fontSize: "inherit",
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
            }}
          >
            Respected Sir/Mam,
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;Please refer to your online proposal dated{" "}
            <b> {formatDate(application_date)}</b> submitted on Ministry’s
            website on <b> {formatDate(application_date) || "_____"}</b> for
            access permission on the subject mentioned above.
            <br />
            2.{" "}
            {Array.isArray(paDetails) && paDetails.length > 0 && (
              <b>{paDetails.map((pa: any) => pa.office_name).join(" / ")}</b>
            )}{" "}
            {" - "}
            <b>
              {paDetails?.map((pa: any) => pa?.authority)?.join(" / ")}
            </b> /{" "}
            <b>
              {capitalizeWords(
                applicantdata?.aeDetails?.[0]?.authority_engineer?.name ??
                  applicantdata?.aeDetails?.authority_engineer?.name ??
                  "Authority Engineer",
              )}
            </b>{" "}
            <b>
              {Array.isArray(applicantdata?.aeDetails)
                ? applicantdata?.aeDetails?.[0]?.ae_agency
                : applicantdata?.aeDetails?.ae_agency}
            </b>{" "}
            vide inspection report dated{" "}
            <b>{formatDate(inspectionDate) || ""}</b> has submitted the
            inspection report for the access permission for subject mentioned
            Retail Outlet and recommended for access permission.
            <br />
            3. The case has been accepted in-principle by this office as per{" "}
            <b>{location_type_name}</b> reach norms based on recommendation of{" "}
            {Array.isArray(paDetails) && paDetails.length > 0 && (
              <b>{paDetails.map((pa: any) => pa.office_name).join(" / ")}</b>
            )}{" "}
            {" - "}
            <b>
              {paDetails?.map((pa: any) => pa?.authority)?.join(" / ")}
            </b> /{" "}
            <b>
              {capitalizeWords(
                applicantdata?.aeDetails?.[0]?.authority_engineer?.name ??
                  applicantdata?.aeDetails?.authority_engineer?.name ??
                  "Authority Engineer",
              )}
            </b>{" "}
            <b>
              {Array.isArray(applicantdata?.aeDetails)
                ? applicantdata?.aeDetails?.[0]?.ae_agency
                : applicantdata?.aeDetails?.ae_agency}
            </b>{" "}
            which is valid upto one year from the date of issue of this letter,
            subject to the following general conditions:
          </Typography>

          {/* General Conditions */}
          <Box
            component="ol"
            type="i"
            sx={{
              pl: 3,
              mb: 2,
              fontSize: "inherit",
              lineHeight: 1.45,
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
              breakInside: "auto",
              pageBreakInside: "auto",
              overflowWrap: "break-word",
              wordBreak: "normal",
              "& > li": {
                breakInside: "auto",
                pageBreakInside: "auto",
                overflowWrap: "break-word",
                wordBreak: "normal",
              },
            }}
          >
            <li>
              The instant approval is based on the submissions made by the
              applicant as verified by the{" "}
              {Array.isArray(paDetails) && paDetails.length > 0 && (
                <b>{paDetails.map((pa: any) => pa.office_name).join(" / ")}</b>
              )}{" "}
              {" - "}
              <b>
                {paDetails?.map((pa: any) => pa?.authority)?.join(" / ")}
              </b> /{" "}
              <b>
                {capitalizeWords(
                  applicantdata?.aeDetails?.[0]?.authority_engineer?.name ??
                    applicantdata?.aeDetails?.authority_engineer?.name ??
                    "Authority Engineer",
                )}
                <b>
                  {Array.isArray(applicantdata?.aeDetails)
                    ? applicantdata?.aeDetails?.[0]?.ae_agency
                    : applicantdata?.aeDetails?.ae_agency || "AE Agency"}
                </b>{" "}
              </b>
              . The Applicant is responsible for the details provided in the
              application. Any misrepresentations, omission or suppression of
              facts or disclosure of incomplete facts detected at any stage
              shall lead to withdrawal of this approval with cost to the
              applicant.
            </li>
            <li>
              The Oil company may construct the access to the proposed fuel
              station, as per approved drawings at their own cost within 12
              months of the issue of this Provisional NOC.
            </li>
            <li>
              In case the construction is not done in one year of the issue of
              this provisional NOC, the same shall be deemed to be cancelled,
              unless renewed by the Competent Authority.
            </li>
            <li>
              The Provisional NOC shall be valid only upon the successful
              realization of the requisite fee as per para 2.11 of the MoRTH
              Circular no. RW/NH-33032/01/2017-S&R(R) dated 26.06.2020 to the
              Central Government Account through Bharatkosh Portal.
            </li>
            <li>
              The issue of final formal permission including issuance of signed
              license deed would be subject to the certification by the{" "}
              {Array.isArray(paDetails) && paDetails.length > 0 && (
                <b>{paDetails.map((pa: any) => pa.office_name).join(" / ")}</b>
              )}{" "}
              {" - "}
              <b>
                {paDetails?.map((pa: any) => pa?.authority)?.join(" / ")}
              </b> /{" "}
              <b>
                {capitalizeWords(
                  applicantdata?.aeDetails?.[0]?.authority_engineer?.name ??
                    applicantdata?.aeDetails?.authority_engineer?.name ??
                    "Authority Engineer",
                )}
              </b>{" "}
              <b>
                {Array.isArray(applicantdata?.aeDetails)
                  ? applicantdata?.aeDetails?.[0]?.ae_agency
                  : applicantdata?.aeDetails?.ae_agency || "AE Agency"}
              </b>{" "}
              that the constructions have been carried out by owner in
              compliance with the provisions approved by this officer as per
              approved layout/location plan and as per Ministry’s guidelines
              issued vide circular No. RW/NH-33032/01/2017-S&R(R) dated
              26.06.2020. Hence it is directed to submit the detailed compliance
              report of this Provisional NOC along with completion certificate
              after construction of access road as per approved layout /
              location plan from the{" "}
              {Array.isArray(paDetails) && paDetails.length > 0 && (
                <b>{paDetails.map((pa: any) => pa.office_name).join(" / ")}</b>
              )}{" "}
              {" - "}
              <b>
                {paDetails?.map((pa: any) => pa?.authority)?.join(" / ")}
              </b> /{" "}
              <b>
                {capitalizeWords(
                  applicantdata?.aeDetails?.[0]?.authority_engineer?.name ??
                    applicantdata?.aeDetails?.authority_engineer?.name ??
                    "Authority Engineer",
                )}
              </b>{" "}
              {"- "}{" "}
              <b>
                {Array.isArray(applicantdata?.aeDetails)
                  ? applicantdata?.aeDetails?.[0]?.ae_agency
                  : applicantdata?.aeDetails?.ae_agency || "AE Agency"}
              </b>{" "}
              for execution of license deed at the time of Final NOC.
            </li>
            <li>
              The concerned Oil Company would be allowed to energize the fuel
              station only after the final approval by the Competent Authority.
            </li>
            <li>
              If the fuel station has been energized without the final approval/
              signing of licensee deed from the Highway Administration,
              necessary action as per para. 2.11 of MoRTH circular No.
              RW/NH-33032/01/2017-S&R(R) dated 26.06.2020 may be taken under
              which a penalty of Rs. 2,50,000.00 shall be imposed on the Oil
              Company to regularize such fuel station.
            </li>
            <li>
              The drinking water and toilet facilities shall be provided at the
              fuel station. Such facilities shall be accessible to the public
              round the clock. In order to inform the public about these, a
              retro reflective display board shall be installed at the buffer
              strip in front of the fuel station.
            </li>
            <li>
              In the event of any comments or shortcomings are pointed by this
              office in due course of time even after issue of NOC/ final
              approval, same shall be incorporated in drawing/layout plan and
              shall be rectified by the applicant as per clause 2.7 and clause
              11.0 of Ministry’s letter No. RW/NH-33032/01/2017-S&R(R) dated
              26.06.2020.
            </li>
            <li>Deleted.</li>
            <li>
              The requisite clearances from concerned department for tree
              cutting and shifting of roadside utilities like electric line,
              water/sewer pipeline/canal shall be obtained by the applicant if
              any required at his own cost for construction of service road as
              per approved drawing and applicant shall solemnly responsible for
              the same.
            </li>
            <li>
              Height restrictions of building structure shall be as per local
              Govt. guidelines and there should be sufficient parking inside so
              that there is no overflow of vehicles on approach road.
            </li>
            <li>
              Minimum desirable standards for control line and building line
              from center of Project Highway to preserve sufficient space for
              road as per applicability under Ribbon Development, Fire
              department and other Authorities Rules and Regulations to be
              followed.
            </li>
          </Box>
          <Typography
            sx={{
              fontSize: "inherit",
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
            }}
          >
            4. The compliance of the following Special conditions of the ‘In-
            principle’ approval shall be ensured and submitted at the time of
            Final NOC:
            {/* <Box component="ol" type="i" sx={{ pl: 3, mt: 1 }}>
              <li>
                The applicant shall construct the service road of{" "}
                {service_road_length || "N/A"} m length and having{" "}
                {service_road_width || "N/A"} m width as per approved drawings
                for the Access purpose. The direct access to the NH is not
                allowed.
              </li>
              <span
                style={{
                  textAlign: "center",
                  margin: "0 auto",
                  fontSize: "13px",
                }}
              >
                OR <br />
                The Applicant shall construct Acceleration and Deceleration lane
                as per approved drawings for the Access purpose. The direct
                access to the NH is not allowed
              </span>

              <li>
                Any other condition as recommended by the{""}{" "}
                <b>
                  {roDetails?.ro_name} - {roDetails?.office_name}{" "}
                </b>{" "}
                {"-"} <b>{applicantdata?.ca_authority}</b>{" "}
                {Array.isArray(paDetails) && paDetails.length > 0 && (
                  <b>
                    / {paDetails.map((pa: any) => pa.office_name).join(" / ")}
                  </b>
                )}{" "}
                {" - "}
                <b>
                  {paDetails?.map((pa: any) => pa?.authority)?.join(" / ")}
                </b>{" "}
              </li>
            </Box> */}
          </Typography>
          <Typography
            sx={{
              my: 1,
              fontSize: "inherit",
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
            }}
          >
            <b>
              Special Conditions of approval for the compliances by the
              applicant:
            </b>
            <Box component="ol" sx={{ pl: 1, mb: 2 }}>
              {applicantdata?.ca_provisional_remarks?.comments}
            </Box>
          </Typography>
          <br />
          {/* Footer */}
          <Typography
            sx={{
              ml: 0,
              fontSize: "inherit",
              lineHeight: 1.45,
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
              overflowWrap: "break-word",
              wordBreak: "normal",
              breakInside: "avoid",
              pageBreakInside: "avoid",
            }}
          >
            Yours faithfully,
          </Typography>
          <Typography
            sx={{
              fontWeight: 700,
              ml: 0,
              fontSize: "inherit",
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
            }}
          >
            {roDetails?.ro_name} - {roDetails?.office_name || "____"} {"-"}{" "}
            {applicantdata?.ca_authority} <br />
            For Highway Administration
            <br />
            (Digitally signed)
          </Typography>
          <Typography
            sx={{
              mt: 5,
              ml: 1,
              textAlign: "left",
              fontSize: "inherit",
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
            }}
          >
            Encl: Digitally signed layout plan
          </Typography>
          <Divider sx={{ my: 2 }} />
          <Typography
            sx={{
              mb: 1,
              fontSize: "inherit",
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
            }}
          >
            <b>Copy to:</b>
            <br />
            <b>
              1.{" "}
              {Array.isArray(paDetails) && paDetails.length > 0 && (
                <b>{paDetails.map((pa: any) => pa.office_name).join(" / ")}</b>
              )}{" "}
              {" - "}
              {paDetails?.map((pa: any) => pa?.authority)?.join(" / ")}{" "}
              {applicantdata?.is_legacy ? (
                <span>for information and necessary actions.</span>
              ) : (
                <>
                  {" "}
                  With request to keep original electronic Bank Guarantee (e-BG)
                  vide BG no:
                  {bgDetails?.bank_guarantee_no || "___"} dated{" "}
                  {formatDate(bgDetails?.bg_isssue_date) || "___"} valid up to{" "}
                  {formatDate(bgDetails?.bg_validity_date) || "___"} from{" "}
                  {bgDetails?.bg_bank_name || "___"} in your safe custody.{" "}
                </>
              )}
            </b>
          </Typography>
        </Paper>
      </Box>
    </>
  );
};

export default RetailLicenseContent;
